
export const appConstant = {
  // NEWPORT OUTRIGGER CANOE CLUB
  CUSTOMER_ID: 2307,
  USER_ID: 10615,
  // Product Category
  PRODUCT_CATEGORY_ID: 0,
  // UPS Ground
  DELIVERY_METHOD_ID: 1,
  // Paid on invoice
  PAYMENT_METHOD_ID: 1,
  // 
  CUSTOMER_PROFILE: 'PROFILE',
  // Subdirecory
  DOCUMENT_ROOT: '',
  // Base URL
  // BASE_URL = "https://admin.psggo.com/api",
}
